module.exports = __webpack_public_path__ + "img/KM.d7b474ee.svg";